var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import { GBTypography } from '@leapfinance/geebee-component-library';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { Accordion, AccordionDetails, AccordionSummary, Button, CircularProgress, Skeleton } from '@mui/material';
import noop from 'lodash/noop';
import { nanoid } from 'nanoid';
import Download from '../../geebee/icons/unisetuDashboard/Download';
import BusinessInsightCard from './BusinessInsightCard';
var BusinessInsightsSection = function (_a) {
    var _b, _c;
    var title = _a.title, isLoading = _a.isLoading, downloading = _a.downloading, downloadEnabled = _a.downloadEnabled, onDownload = _a.onDownload, onShowMoreClick = _a.onShowMoreClick, _d = _a.shouldWrapInAccordion, shouldWrapInAccordion = _d === void 0 ? false : _d, onAccordionExpand = _a.onAccordionExpand, defaultExpanded = _a.defaultExpanded, cards = _a.cards;
    var _e = __read(useState(true), 2), showMore = _e[0], setShowMore = _e[1];
    var _f = __read(useState(false), 2), isAccordionExpanded = _f[0], setIsAccordionExpanded = _f[1];
    var cardsToShow = showMore ? cards === null || cards === void 0 ? void 0 : cards.slice(0, 4) : cards;
    useEffect(function () {
        if (isAccordionExpanded) {
            onAccordionExpand === null || onAccordionExpand === void 0 ? void 0 : onAccordionExpand();
        }
    }, [isAccordionExpanded]);
    useEffect(function () {
        if (isAccordionExpanded || typeof defaultExpanded === 'undefined')
            return;
        setIsAccordionExpanded(defaultExpanded);
    }, [defaultExpanded]);
    var handleDownload = function (event) {
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        onDownload === null || onDownload === void 0 ? void 0 : onDownload();
    };
    if (isLoading) {
        return (React.createElement("div", null,
            React.createElement("div", { className: "lfc-py-4 lfc-px-6 lfc-flex lfc-flex-col lfc-gap-y-6 lfc-items-start lfc-rounded-lg lfc-bg-white lfc-border lfc-border-neutralLightGrey-400" },
                React.createElement(Skeleton, { variant: "text", sx: { fontSize: '2rem', width: '100%' } }),
                React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-4 lfc-w-full md:lfc-grid md:lfc-grid-cols-4 md:lfc-gap-4" }, new Array(4).fill(0).map(function (item) { return (React.createElement(Skeleton, { key: nanoid(), variant: "rounded", height: '6rem' })); })))));
    }
    return (React.createElement(React.Fragment, null, shouldWrapInAccordion ? (React.createElement(Accordion, { style: {
            boxShadow: 'none',
            borderRadius: '8px'
        }, sx: {
            '::before': {
                background: 'none'
            },
            '& .MuiAccordionSummary-content': {
                margin: '0px',
                marginY: '24px'
            },
            '& .MuiAccordionSummary-content.Mui-expanded': {
                margin: '0px',
                marginY: '24px'
            },
            '& .MuiButtonBase-root': {
                minHeight: 'fit-content'
            },
            '& .MuiButtonBase-root.Mui-expanded': {
                minHeight: 'fit-content'
            }
        }, elevation: 0, expanded: isAccordionExpanded, onChange: function () {
            setIsAccordionExpanded(!isAccordionExpanded);
        } },
        React.createElement(AccordionSummary, { expandIcon: React.createElement(ExpandMoreRoundedIcon, null) },
            React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-w-full" },
                React.createElement(GBTypography, { variant: "h2Semibold", className: "lfc-text-black" }, title),
                downloadEnabled && isAccordionExpanded ? (React.createElement("div", { role: "button", className: "lfc-p-1 lfc-mr-2 lfc-rounded lfc-bg-white lfc-shadow-unisetu-summarydashboard-download lfc-border-[0.778px] lfc-border-gray-300 ".concat(downloadEnabled ? '' : 'lfc-opacity-40 lfc-cursor-not-allowed'), onClick: downloadEnabled ? handleDownload : noop }, downloading ? React.createElement(CircularProgress, { size: '1.5rem' }) : React.createElement(Download, null))) : null)),
        React.createElement(AccordionDetails, null,
            React.createElement("div", { className: "lfc-py-4 lfc-px-6 lfc-flex lfc-flex-col lfc-gap-y-6 lfc-items-start lfc-rounded-lg lfc-bg-white" },
                React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-4 lfc-w-full md:lfc-grid md:lfc-grid-cols-4 md:lfc-gap-4" }, cards === null || cards === void 0 ? void 0 : cards.map(function (card) { return (React.createElement(BusinessInsightCard, __assign({ key: card.id }, card))); })),
                ((_b = cards === null || cards === void 0 ? void 0 : cards.length) !== null && _b !== void 0 ? _b : 0) > 4 ? (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-center lfc-w-full" },
                    React.createElement(Button, { variant: "text", onClick: function () {
                            setShowMore(function (s) { return !s; });
                            onShowMoreClick === null || onShowMoreClick === void 0 ? void 0 : onShowMoreClick(showMore);
                        } },
                        React.createElement(GBTypography, { variant: "link2", className: "lfc-text-black lfc-underline lfc-normal-case" }, showMore ? 'Show More' : 'Show Less')))) : null)))) : (React.createElement("div", { className: "lfc-py-4 lfc-px-6 lfc-flex lfc-flex-col lfc-gap-y-6 lfc-items-start lfc-rounded-lg lfc-bg-white lfc-border lfc-border-neutralLightGrey-400" },
        React.createElement("div", { className: "lfc-flex lfc-justify-between lfc-items-center lfc-w-full" },
            React.createElement(GBTypography, { variant: "h2Semibold", className: "lfc-text-black" }, title),
            downloadEnabled ? (React.createElement("div", { role: "button", className: "lfc-p-1 lfc-rounded lfc-bg-white lfc-shadow-unisetu-summarydashboard-download lfc-border-[0.778px] lfc-border-gray-300 ".concat(downloadEnabled ? '' : 'lfc-opacity-40 lfc-cursor-not-allowed'), onClick: downloadEnabled ? onDownload : noop }, downloading ? React.createElement(CircularProgress, { size: '1.5rem' }) : React.createElement(Download, null))) : null),
        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-y-4 lfc-w-full md:lfc-grid md:lfc-grid-cols-4 md:lfc-gap-4" }, cardsToShow === null || cardsToShow === void 0 ? void 0 : cardsToShow.map(function (card) { return (React.createElement(BusinessInsightCard, __assign({ key: card.id }, card))); })),
        ((_c = cards === null || cards === void 0 ? void 0 : cards.length) !== null && _c !== void 0 ? _c : 0) > 4 ? (React.createElement("div", { className: "lfc-flex lfc-items-center lfc-justify-center lfc-w-full" },
            React.createElement(Button, { variant: "text", onClick: function () {
                    setShowMore(function (s) { return !s; });
                    onShowMoreClick === null || onShowMoreClick === void 0 ? void 0 : onShowMoreClick(showMore);
                } },
                React.createElement(GBTypography, { variant: "link2", className: "lfc-text-black lfc-underline lfc-normal-case" }, showMore ? 'Show More' : 'Show Less')))) : null))));
};
export default BusinessInsightsSection;
//# sourceMappingURL=BusinessInsightsSection.js.map